import React from 'react'
import { useUserInfo } from './useUserInfo'

export function withUserInfo<T>(Component: React.ComponentType<T>) {
  return (props: T) => {
    const result = useUserInfo()

    return <Component {...result} {...props} />
  }
}
